export const Pages = {
    Login: '/login',
    Register: '/registreren',
    Logout: '/logout',
    Uid: '/:uid',
    Puppies: '/mijn-puppies',
    Zindelijkheid: '/zindelijkheid'
}
